import React from "react";
import { Dialog } from "@material-ui/core";
import IAPI from "../../../../models/IAPI";
import { IntegrationStatuses } from "../../IntegrationStatuses";
import IIntegration from "../../../../models/IIntegration";
import { SelectAPIsNonProdDialog } from "./SelectAPIsNonProdDialog";
import { SelectAPIsProdDialog } from "./SelectAPIsProdDialog";

export interface ISelectAPIsDialogProps {
  isOpen: boolean;
  token: string;
  username: string;
  integration: IIntegration;
  currentAPIs: IAPI[];
  setApis: (val: IAPI[]) => void;
  closeDialog: () => void;
  setIntegrationErrors: (val: string[]) => void;
}

const SelectAPIsDialog = (props: ISelectAPIsDialogProps) => {
  const { isOpen, token, username, integration, currentAPIs, setApis, closeDialog, setIntegrationErrors } = props;

  return (
    <Dialog open={isOpen} onClose={closeDialog} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description" maxWidth="xl">
      {integration.Status.ID === IntegrationStatuses.InDevelopment || integration.Status.ID === IntegrationStatuses.NotStarted ? (
        <SelectAPIsNonProdDialog
          token={token}
          integration={integration}
          currentApis={currentAPIs}
          closeDialog={closeDialog}
          setIntegrationErrors={setIntegrationErrors}
          setApis={setApis}
        />
      ) : (
        <SelectAPIsProdDialog token={token} username={username} integration={integration} currentAPIs={currentAPIs} closeDialog={closeDialog} />
      )}
    </Dialog>
  );
};

export default SelectAPIsDialog;
